import React from 'react';
export default function RowStatusCell ({id, row}) {
  const value = row[id];
  const label = `${value}` === '2' ? ['success', 'Complete'] : ['warning', 'Incomplete'] ;

  return <span className={`label label-light-${label[0]} label-pill label-inline`}>{label[1]}</span>
}
